import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentPost = {
    path: "/consent",
    method: RouteHttpVerb.POST,
    obfuscatePath: "keep-last-part"
};
export { locationRestConsentPost };
